import ListBullet from 'assets/format_list_bulleted.svg'
import { Menu, MenuItem, IconButton } from '@mui/material'
import { type GridRenderCellParams } from '@mui/x-data-grid'
import { useState } from 'react'
import { type CheckInPolicyWelcomeBackMilestonePointBonusScheduleDTO } from 'types/api'

export const DeleteWelcomeBackMilestoneBonus = ({
  params,
  setRowData,
  toggleIsOpen,
}: {
  params: GridRenderCellParams<CheckInPolicyWelcomeBackMilestonePointBonusScheduleDTO>
  setRowData: React.Dispatch<
    React.SetStateAction<
      CheckInPolicyWelcomeBackMilestonePointBonusScheduleDTO | null | undefined
    >
  >
  toggleIsOpen: () => void
}) => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(null)

  const handleMenuOpen = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <img src={ListBullet} width={4} height={16} alt="options icon" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            setRowData(params.row)
            handleMenuClose()
            toggleIsOpen()
          }}
        >
          Delete Welcome Back Milestone Bonus
        </MenuItem>
      </Menu>
    </>
  )
}
